import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {FormGeneratorService} from "../../components/common/fields/form-generator.service";
import {FieldDefinition} from "../../model/field-definition";

@Injectable({
  providedIn: 'root'
})
export class UserFavoriteFormGeneratorService implements FormGeneratorService {

  constructor() {
  }

  getQuestions(): Observable<FieldDefinition<any>[]> {
    const questions = [
      new FieldDefinition<string>({
        key: "url",
        label: 'URL du favori',
        type: 'text',
        required: true,
        order: 1
      }),
      new FieldDefinition<string>({
        key: "name",
        label: 'Nom du favori',
        type: 'text',
        required: true,
        order: 2
      })
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }
}
